import React, { useState, useEffect, useContext } from 'react';
import { Context } from './../../Context';
import {IProps} from './types';
import * as S from './styles';
import D from "@assets/themes/dimensions";
import ImagePicker from './ImagePicker';
import FontFamilyPicker from './FontFamilyPicker';
import ColorPicker from './ColorPicker';
import NewTextPicker from './NewTextPicker';
import NewShapePicker from './NewShapePicker';
import EditImagePicker from './EditImagePicker';
import MultiEditingPickerConsumer from './MultiEditingPicker/consumer';
import LayersPicker from './LayersPicker';
import SimilarImages from './SimilarImages';
import { IPickerFontFamilyProperties, IPickerSearchImagesProperties } from '../../types';
import BrandLibraryPicker from './BrandLibraryPicker';
import VersionHistoryPicker from './VersionHistoryPicker';

const Pickers:React.FC<IProps> = (props) => {
  const context = useContext(Context);
  const show: boolean = ((context.editorStatus.currentPicker==="MultiEditing" && (context.multiEditingConfig?.categories.length??0)>0) || (context.editorStatus.currentPicker!=="MultiEditing" && context.editorStatus.currentPicker!==undefined));
  const showsub : boolean = context.editorStatus.currentSubPicker!== undefined
  
  const [reloadMultiEditing, setReloadMultiEditing] = useState(true);

  useEffect(() => {
    if (context.multiEditingConfig) {
      setReloadMultiEditing(false);
    }
  }, [context.multiEditingConfig])

  useEffect(() => {
    setReloadMultiEditing(true);
  }, [reloadMultiEditing])
  
  const handleFocus = (e: React.FocusEvent<HTMLDivElement>) => {
    context.onIsPickerFocued(true);
  }

  const handleBlur = (e: React.FocusEvent<HTMLDivElement>) => {
    context.onIsPickerFocued(false);
  }
  
  
  return (
    <S.RootContainer>
    { 
        <S.Root
          widthValue={(show ) ? (context.editorStatus.currentPicker==="VersionHistory"?'334px': `${D.PICKER_BOX_WIDTH}px`) : '0px'}
          opacityValue={(show ) ? '1' : '0'}
          tabIndex={0}
          onFocus={handleFocus}
          onBlur={handleBlur}
        >
            { (context.editorStatus.currentPicker==="FontFamily") && <FontFamilyPicker isSearching={(context.editorStatus.pickerProperties as IPickerFontFamilyProperties).isSearching} searchValue={(context.editorStatus.pickerProperties as IPickerFontFamilyProperties).searchValue}/> }
            { (context.editorStatus.currentPicker==="Color") && <ColorPicker drawBox={false}/> }
            { (context.editorStatus.currentPicker==="AddNewText") && <NewTextPicker/> }
            { (context.editorStatus.currentPicker==="MultiEditing" && reloadMultiEditing) && <MultiEditingPickerConsumer /> }
            { (["AddNewImage", "ReplaceImage"].includes(context.editorStatus.currentPicker ?? '')) && <ImagePicker/> }
            { (context.editorStatus.currentPicker==="AddNewShape") && <NewShapePicker/> }
            { (context.editorStatus.currentPicker==="EditImage") && <EditImagePicker/> }
            { (context.editorStatus.currentPicker==="Layers") && <LayersPicker/> }
            { (context.editorStatus.currentPicker==="BrandLibrary") && <BrandLibraryPicker/> }
            { (context.editorStatus.currentPicker==="VersionHistory") && <VersionHistoryPicker/> }
        </S.Root>
    }   
    {
        <S.SubPicker
           widthValue={(showsub ) ? '263px' : '0px'}
          opacityValue={(showsub ) ? '1' : '0'}
        >
          { (context.editorStatus.currentSubPicker==="SearchImages") && <SimilarImages/> }
        </S.SubPicker>
    }
    </S.RootContainer>
  );
}

export default Pickers;